import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Captcha from "react-numeric-captcha";
import "../../../../_metronic/_assets/css/captcha.css";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const captchaCheck =
  process.env.REACT_APP_CHECK_CAPTCHA.toLowerCase() === "true";

const initialValues = {
  userName: "",
  password: "",
  captchaInput: !captchaCheck,
};

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [captchaState, setCaptchaState] = useState(!captchaCheck);
  const captchaField = useRef(null);

  const history = useHistory();

  const LoginSchema = Yup.object().shape({
    // email: Yup.string()
    //   .email("Wrong email format")
    //   .min(3, "Minimum 3 symbols")
    //   .max(50, "Maximum 50 symbols")
    //   .required(
    //     intl.formatMessage({
    //       id: "AUTH.VALIDATION.REQUIRED_FIELD",
    //     })
    //   ),
    userName: Yup.string()
      .min(
        3,
        intl.formatMessage(
          { id: "AUTH.VALIDATION.MIN_LENGTH_FIELD" },
          { lenght: 3 }
        )
      )
      // .min(3, `${minUsernameError}` )
      .max(
        15,
        intl.formatMessage(
          { id: "AUTH.VALIDATION.MAX_LENGTH_FIELD" },
          { lenght: 15 }
        )
      )
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .min(
        3,
        intl.formatMessage(
          { id: "AUTH.VALIDATION.MIN_LENGTH_FIELD" },
          { lenght: 3 }
        )
      )
      .max(
        15,
        intl.formatMessage(
          { id: "AUTH.VALIDATION.MAX_LENGTH_FIELD" },
          { lenght: 15 }
        )
      )
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  useEffect(() => {
    if (captchaCheck) {
      formik.setFieldValue("captchaInput", captchaState);
    } else {
      formik.setFieldValue("captchaInput", true);
    }
  }, [captchaState]);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      if (!values.captchaInput) {
        disableLoading();
        setSubmitting(false);
        setStatus(
          intl.formatMessage({
            id: "AUTH.GENERAL.CAPTCHA_INVALID",
          })
        );
        if (captchaField.current) captchaField.current.refresh();
        setCaptchaState(false);
        return;
      }
      setTimeout(() => {
        login(values.userName, values.password)
          .then((response) => {
            // console.log("login response :")
            // console.log(response)
            // console.log("access token " + JSON.stringify(response.data.data.accessToken));
            // console.log("access user " + JSON.stringify(response.data.data.user));
            // console.log("access menu " + JSON.stringify(response.data.data.menu));
            sessionStorage.setItem(
              "authUser",
              JSON.stringify(response.data.data.user)
            );
            sessionStorage.setItem(
              "authUserMenu",
              JSON.stringify(response.data.data.menu)
            );
            sessionStorage.setItem(
              "accessToken",
              JSON.stringify(response.data.data.accessToken)
            );

            if (response.data.data.user.needChangePassword) {
              history.push("/auth/change-password");
            } else {
              props.login(response.data.data.accessToken);
            }
          })
          .catch((error) => {
            disableLoading();
            if (captchaField.current) captchaField.current.refresh();
            setCaptchaState(false);
            setSubmitting(false);
            if (error.response) {
              formik.setStatus(error.response.data.Message);
            } else {
              formik.setStatus(
                intl.formatMessage({
                  id: "AUTH.VALIDATION.INVALID_LOGIN",
                })
              );
            }
          });
      }, 1000);
      //   login(values.email, values.password)
      //     .then(({ data: { accessToken } }) => {
      //       disableLoading();
      //       props.login(accessToken);
      //     })
      //     .catch(() => {
      //       disableLoading();
      //       setSubmitting(false);
      //       setStatus(
      //         intl.formatMessage({
      //           id: "AUTH.VALIDATION.INVALID_LOGIN",
      //         })
      //       );
      //     });
      // }, 1000);
    },
  });

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <img
          src={toAbsoluteUrl("/images/LogoUni/Logo_CFU.png")}
          alt="-"
          style={{ width: "8.5rem" }}
        />

        <h2 className="font-size-h1 text-light">
          {/* <FormattedMessage id="AUTH.LOGIN.TITLE" /> */}
        </h2>
        <p className=" font-weight-bold text-light">
          <FormattedMessage id="UNIVERSITY.NAME" />
          <br />
          <FormattedMessage id="AUTH.LOGIN.TITLE" />
        </p>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        {/* {formik.status ? (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        ) : (
          <div className="mb-10 alert alert-custom alert-light-info alert-dismissible">
            <div className="alert-text ">
              <FormattedMessage id="AUTH.VALIDATION.LOGIN_DESCRIPTION" />
            </div>
          </div>
        )} */}

        {formik.status && (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        )}

        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder={intl.formatMessage({
              id: "AUTH.INPUT.USERNAME",
            })}
            type="userName"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "userName"
            )}`}
            name="userName"
            {...formik.getFieldProps("userName")}
          />
          {formik.touched.userName && formik.errors.userName ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.userName}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder={intl.formatMessage({
              id: "AUTH.INPUT.PASSWORD",
            })}
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "password"
            )}`}
            name="password"
            {...formik.getFieldProps("password")}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        {captchaCheck && (
          <div
            id="divCaptcha"
            className="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <Captcha
              ref={captchaField}
              onChange={(status) => {
                setCaptchaState(status);
              }}
              placeholder={intl.formatMessage({
                id: "AUTH.GENERAL.CAPTCHA_PH",
              })}
            />
          </div>
        )}
        {/* <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="Captcha"
            type="captcha"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "captcha"
            )}`}
            name="captcha"
            {...formik.getFieldProps("captcha")}
          />
          <audio id="audio"  preload="metadata" width="300" height="32" src="/UserControls/AudioPlayer.aspx"></audio>
          <img  id="SoundIcon" src="images/Icon/Sound.gif" style="width:10%; padding-top:2%;float:right;"  title="پخش صوتی کد امنیتی" alt="پخش صوتی کد امنیتی" onclick="playaudio();return false;" />
                            
          {formik.touched.captcha && formik.errors.captcha ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.captcha}</div>
            </div>
          ) : null}
        </div> */}
        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">


          <button
            id="kt_login_signin_submit"
            type="submit"
            // disabled={formik.isSubmitting}
            disabled={
              captchaState === true || !captchaCheck
                ? formik.isSubmitting
                : true
            }
            className={`btn btn-success btn-block font-weight-bold px-9 py-4 my-3`}
            // style={{
            //   backgroundImage: `url(${toAbsoluteUrl("/images/Style/bgLogin.png")})`
            // }}
          >
            <span>
              {" "}
              <FormattedMessage id="AUTH.GENERAL.LOGIN" />{" "}
            </span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
